const number = value => value === null || value === undefined || value === '' || !Number.isFinite(Number(value)) ? null : Number(value);
const realmStats = { 451: 'intellect', 452: 'wisdom', 453: 'charisma', wizardry: 'intellect', channeling: 'wisdom', psionics: 'charisma' };

export const calculateMaxPp = (being = {}) => {
  const fields = [...new Set((Array.isArray(being.spells) ? being.spells : [])
    .filter(spell => !['11', 'acquisition'].includes(String(spell.idSpellUsage ?? '').trim().toLowerCase()))
    .map(spell => realmStats[String(spell.realm ?? '').trim().toLowerCase()]).filter(Boolean))];
  if (!fields.length) return 0;
  const stat = fields.reduce((sum, field) => sum + Math.max(0, number(being[field]) ?? 0), 0) / fields.length;
  return Math.max(0, Math.floor(stat * Math.max(0, number(being.level) ?? 0)));
};

export const resolveBeingMana = (being = {}) => {
  const storedMax = number(being.maxPp ?? being.max_pp);
  const maxPp = storedMax > 0 ? storedMax : calculateMaxPp(being);
  const current = number(being.currentPp ?? being.current_pp);
  return { maxPp, currentPp: storedMax > 0 ? Math.max(0, Math.min(maxPp, current ?? maxPp)) : maxPp };
};
